import {XW2GameMode, XwaysHoarder2} from "../../../XwaysHoarder2";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {SimplePresentation, SimplePresentationRunnerController} from "../../../SimplePresentationRunner";
import {gsap} from "gsap";


export class PlusFsPresentation implements SimplePresentation {
    name: string = "PlusFsPresentation";

    shouldRun(): boolean {
        return (XwaysHoarder2.model.mode === XW2GameMode.FREESPIN || XwaysHoarder2.model.mode === XW2GameMode.SUPER_FREESPIN)
    }

    start(controller: SimplePresentationRunnerController): gsap.core.Timeline {
        /*
            if(XwaysHoarder2.model.mode === XW2GameMode.FREESPIN || XwaysHoarder2.model.mode === XW2GameMode.SUPER_FREESPIN) {
                XwaysHoarder2.plusFsView.playSpineFromSymPos(this.reel.id, this.symID, () => {
                const diff: number = (XwaysHoarder2.model.data.freespinsLeft - 1) - XwaysHoarder2.model.data.addedNumberOfFreeSpinInThisSpin;
                SlotGame.keypadPlugin.setZeroBetSpinCounter(diff + 1);
                });
         */
        const tl = gsap.timeline();
        const reels = XwaysHoarder2.model.data.reels;
        const diff: number = (XwaysHoarder2.model.data.freespinsLeft) - XwaysHoarder2.model.data.addedNumberOfFreeSpinInThisSpin;
        let durCount :number = 0;
        let count: number = 1;

        reels.forEach((reel, rId) => {
           reel.forEach((sym, sId) => {
               if(sym === "SC") {
                   tl.add(() => {XwaysHoarder2.plusFsView.playSpineFromSymPos(rId, sId, () => {
                       SlotGame.keypadPlugin.setZeroBetSpinCounter(diff + count++);
                   })}, "+=0.25");
                   durCount = 2.3;
               }
           });
        });

        tl.add(() => {
            XwaysHoarder2.plusFsView.resetAnimations();
            controller.setSkipCallback();
            controller.finish();
        }, durCount);
        return tl;
    }

}